import React, { CSSProperties } from 'react';
import { withTranslation } from 'react-i18next';

class CatagoryThum extends React.Component {
  render() {
    const { t } = this.props;
    const { bg, title, onClick } = this.props;
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ ...rootstyle }}>
          <div style={{ ...imagestyle, backgroundImage: `url(${bg})`, cursor: 'pointer' }} onClick={onClick} />
          <div style={{ ...titlestyle }}>{title}</div>
          <div onClick={onClick} style={{ ...morestyle }}>
            {t('shop_now')}
          </div>
        </div>
      </div>
    );
  }
}

const rootstyle = {
  width: 300,
  textAlign: 'center',
};

const imagestyle = {
  width: 300,
  height: 400,
  backgroundSize: 'auto',
  backgroundPosition: 'center',
};

const titlestyle = {
  fontFamily: 'NSCJKrB',
  color: 'black',
  fontSize: 24,
  marginTop: 34,
};

const morestyle = {
  fontFamily: 'NSCJKrB',
  color: 'black',
  fontSize: 18,
  marginTop: 24,
  cursor: 'pointer',
  padding: '10px 60px',
  border: '1px solid black',
  display: 'inline-block',
};

export default withTranslation()(CatagoryThum);
